<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="3" class="my-0">
                    <select-accounting-firm-user
                        @collaborator-has-changed="getItems"
                    />
                </b-col>
                <b-col md="4" class="my-1">
                    <dead-line-filter />
                </b-col>
                <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                    >Effacer
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="id"
                @filtered="onFiltered"
            >
                <template #cell(m1)="data">
                    <month-charge-handler :charge="data.item.m1" />
                </template>
                <template #cell(m2)="data">
                    <month-charge-handler :charge="data.item.m2" />
                </template>
                <template #cell(m3)="data">
                    <month-charge-handler :charge="data.item.m3" />
                </template>
                <template #cell(m4)="data">
                    <month-charge-handler :charge="data.item.m4" />
                </template>
                <template #cell(m5)="data">
                    <month-charge-handler :charge="data.item.m5" />
                </template>
                <template #cell(m6)="data">
                    <month-charge-handler :charge="data.item.m6" />
                </template>
                <template #cell(m7)="data">
                    <month-charge-handler :charge="data.item.m7" />
                </template>
                <template #cell(m8)="data">
                    <month-charge-handler :charge="data.item.m8" />
                </template>
                <template #cell(m9)="data">
                    <month-charge-handler :charge="data.item.m9" />
                </template>
                <template #cell(m10)="data">
                    <month-charge-handler :charge="data.item.m10" />
                </template>
                <template #cell(m11)="data">
                    <month-charge-handler :charge="data.item.m11" />
                </template>
                <template #cell(m12)="data">
                    <month-charge-handler :charge="data.item.m12" />
                </template>

                <template #cell(year)="data">
                    <month-charge-handler :charge="data.item.year" />
                </template>

                <template slot="bottom-row">
                    <td class="td-bold bg-light">TOTAL</td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM1" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM2" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM3" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM4" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM5" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM6" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM7" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM8" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM9" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM10" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM11" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalM12" />
                    </td>
                    <td class="text-right td-bold bg-light">
                        <month-charge-handler :charge="totalY" />
                    </td>
                </template>
            </b-table>
            <!-- /Table -->
            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '../../../common/components/loading.vue'
import monthChargeHandler from '../../../common/components/MonthChargeHandler.vue'
import DeadLineFilter from '../../../activity_management/activity/components/DeadLineFilter.vue'
import TableHandler from '../../../common/mixins/TableHandler.vue'
import DashboardHandler from '../../mixins/DashboardHandler.vue'
import SelectAccountingFirmUser from '../../../activity_management/time-sheets/components/SelectAccountingFirmUser.vue'

export default {
    name: 'TableChargeCollaborator',

    components: {
        DeadLineFilter,
        monthChargeHandler,
        loading,
        SelectAccountingFirmUser,
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            loading: false,
            fields: [
                {
                    key: 'name',
                    label: 'Collaborateur',
                    sortable: true,
                },
                {
                    key: 'm1',
                    label: 'jan',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm2',
                    label: 'fév',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm3',
                    label: 'mar',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm4',
                    label: 'avr',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm5',
                    label: 'mai',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm6',
                    label: 'jun',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm7',
                    label: 'jul',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm8',
                    label: 'aôu',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm9',
                    label: 'sep',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm10',
                    label: 'oct',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm11',
                    label: 'nov',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'm12',
                    label: 'déc',
                    sortable: true,
                    class: 'text-right',
                },
                {
                    key: 'year',
                    label: 'TOTAL',
                    sortable: true,
                    class: 'text-right td-bold',
                },
            ],
        }
    },

    computed: {
        ...mapState({
            accountingFirmUser: (state) =>
                state.timeSheetsVM.filters.accountingFirmUser,
        }),

        totalM1() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m1.duration),
                0.0
            )
            return { duration: value }
        },

        totalM2() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m2.duration),
                0.0
            )
            return { duration: value }
        },

        totalM3() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m3.duration),
                0.0
            )
            return { duration: value }
        },

        totalM4() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m4.duration),
                0.0
            )
            return { duration: value }
        },

        totalM5() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m5.duration),
                0.0
            )
            return { duration: value }
        },

        totalM6() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m6.duration),
                0.0
            )
            return { duration: value }
        },

        totalM7() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m7.duration),
                0.0
            )
            return { duration: value }
        },

        totalM8() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m8.duration),
                0.0
            )
            return { duration: value }
        },

        totalM9() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m9.duration),
                0.0
            )
            return { duration: value }
        },

        totalM10() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m10.duration),
                0.0
            )
            return { duration: value }
        },

        totalM11() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m11.duration),
                0.0
            )
            return { duration: value }
        },

        totalM12() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.m12.duration),
                0.0
            )
            return { duration: value }
        },

        totalY() {
            const value = this.items.reduce(
                (accum, item) => accum + parseFloat(item.year.duration),
                0.0
            )
            return { duration: value }
        },
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'chargeTableCollaborator')
        this.getItems()
    },

    methods: {
        async getItems() {
            if (this.accountingFirmUser > 0) {
                try {
                    this.loading = true
                    const response = await this.$axios.get(
                        `/reporting/charge/table/accountingFirmUsers/${this.accountingFirmUser}/${this.year}/${this.deadlineFilter}`
                    )
                    this.items = response.data
                    this.updateTotalRows()
                    this.loading = false
                } catch (error) {
                    // handle error
                    console.log(error)
                    this.handleErrors(error.response)
                }
            }
        },
    },
}
</script>

<style scoped></style>
